export const INTERCEPTOR_EXCEPTIONS = [
  'screenshot',
  'videos',
  'images',
  'dashboard'
]
